import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

export interface CreateStripeWinbackPromoCodeResponse {
  message: string;
}

const STRIPE_WINBACK_ENDPOINT = "/v3/promocodes/stripe/winback";

const renewStripeSubscriptionWithWinbackCoupon = async ():
  Promise<ApiResponse<CreateStripeWinbackPromoCodeResponse>> => {
  try {
    const response = await paymentGatewayApi.post(
      STRIPE_WINBACK_ENDPOINT,
      undefined,
      { requireAuth: true }
    );
    return { data: { message: response.data?.message ?? "" }, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: STRIPE_WINBACK_ENDPOINT, method: "POST" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error renewing subscription" };
  }
};

export default renewStripeSubscriptionWithWinbackCoupon;
